import { Action } from 'redux';

import {
    SET_FOOD_PERSONS,
    SET_FOOD_COMMENT,
    SET_FOOD_TIME,

    RESERVATION_REQUEST,
    RESERVATION_RESPONSE,
    RESERVATION_ERROR,
    
    RESET_ORDER,

    CONFIRMATION_REQUEST,
    CONFIRMATION_RESPONSE,
    CONFIRMATION_ERROR
} from '../../actions/Food/order';

import { SearchParams } from '../../models/Food/SearchParams';

export interface FoodOrderState {
    searchParams: SearchParams;

    resId: string | null;
    isConfirmed: boolean;
    isConfirming: boolean;

    error: string | null;

    type: string;
    loadingReservation: boolean;
    loadingConfirmation: boolean;
}

const initialState: FoodOrderState = {
    searchParams: {
        persons: 2,
        datetime: null,
        comment: ''
    },
    resId: null,
    error: null,
    isConfirmed: false,
    isConfirming: false,
    type: '',
    loadingReservation: false,
    loadingConfirmation: false
};

export function foodOrder(state: FoodOrderState = initialState, action: Action) {
    switch (action.type) {
        case CONFIRMATION_REQUEST: {
            return {
                ...state,
                isConfirming: true,
                error: initialState.error,
                isConfirmed: false,
                loadingConfirmation: true
            };
        }
        case CONFIRMATION_RESPONSE: {
            return {
                ...state,
                isConfirming: false,
                isConfirmed: true,
                loadingConfirmation: initialState.loadingConfirmation
            };
        }
        case CONFIRMATION_ERROR: {
            const error = String((action as any).error);
            return {
                ...state,
                isConfirming: false,
                isConfirmed: false,
                error,
                loadingConfirmation: initialState.loadingConfirmation
            };
        }

        case RESERVATION_REQUEST: {
            return {
                ...state,
                resId: initialState.resId,
                error: initialState.error,
                isConfirmed: initialState.isConfirmed,
                type: initialState.type,
                loadingReservation: true
            };
        }
        case RESET_ORDER: {
            return {
                ...state,
                resId: initialState.resId,
                error: initialState.error,
                isConfirmed: initialState.isConfirmed,
                type: initialState.type
            };
        }
        case RESERVATION_RESPONSE: {
            const resp = (action as any).response;
            return {
                ...state,
                resId: resp.result.reservation_id,
                type: resp.result.reservation_type,
                loadingReservation: initialState.loadingReservation
            };
        }
        case RESERVATION_ERROR: {
            const error = (action as any).error;
            return {
                ...state,
                error,
                loadingReservation: initialState.loadingReservation
            };
        }

        case SET_FOOD_PERSONS: {
            const num = (action as any).num;
            return {
                ...state,
                searchParams: {
                    ...state.searchParams,
                    datetime: null,
                    persons: num
                }
            };
        }
        case SET_FOOD_TIME: {
            const datetime = (action as any).datetime;
            return {
                ...state,
                searchParams: {
                    ...state.searchParams,
                    datetime: datetime
                }
            };
        }
        case SET_FOOD_COMMENT: {
            const comment = (action as any).comment;
            return {
                ...state,
                searchParams: {
                    ...state.searchParams,
                    comment: comment
                }
            };
        }
        default: {
            return state;
        }
    }
}



// WEBPACK FOOTER //
// ./src/reducers/Food/order.ts